/**
 * Compact status summary for lead ops processing activity (drawer trigger badge).
 */

/**
 * @param {object[]} [events]
 * @returns {{ label: string, color: 'default'|'info'|'success'|'warning'|'error', eventCount: number }}
 */
export function summarizeLeadOpsActivity(events = []) {
  const eventCount = events.length;

  if (eventCount === 0) {
    return {
      label: "No activity yet",
      color: "default",
      eventCount: 0,
    };
  }

  const hasError = events.some((event) => event.status === "error");
  const hasWarning = events.some((event) => event.status === "warning");
  const hasQuotePrepared = events.some(
    (event) => event.type === "pricing.quote.prepared"
  );
  const hasPipelineScheduled = events.some(
    (event) => event.type === "pricing.pipeline.scheduled"
  );
  const hasSkipped = events.some((event) =>
    String(event.type || "").includes("skipped")
  );

  if (hasError) {
    return {
      label: "Needs attention",
      color: "error",
      eventCount,
    };
  }

  if (hasWarning || hasSkipped) {
    return {
      label: "Attention needed",
      color: "warning",
      eventCount,
    };
  }

  if (hasQuotePrepared) {
    return {
      label: "Auto-pricing complete",
      color: "success",
      eventCount,
    };
  }

  if (hasPipelineScheduled) {
    return {
      label: "Processing…",
      color: "info",
      eventCount,
    };
  }

  return {
    label: `${eventCount} event${eventCount === 1 ? "" : "s"}`,
    color: "default",
    eventCount,
  };
}
